import {Pipe, PipeTransform} from '@angular/core';
import {ProductVariation} from "../../products/models/product-variation";

@Pipe({
  name: 'orderVariationsByHeight'
})
export class OrderVariationsByHeightPipe implements PipeTransform {

  transform(value: ProductVariation[], order: 'asc' | 'desc' = 'asc'): ProductVariation[] {
    return [...value].sort((a, b) => {
      if (order === 'asc') return a.height - b.height
      else if (order === 'desc') return b.height - a.height
      else return 0;
    })
  }

}
